const swiperProduct = new Swiper(".home-slider__swiper-one", {
  slidesPerView: 1.4,
  watchOverflow: true,
  breakpoints: {
    400: {
      slidesPerView: 1.4,
    },
    768: {
      slidesPerView: 2.4,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});